module.exports = __webpack_public_path__ + "img/alianza-por-el-gran-cambio.85f6de2d.png";